<template>
  <div id="app">
    <AppNavbar v-if="control_panel != null"></AppNavbar>
    <div
      id="content"
      :class="{
        'login-page': route.name == 'login' || route.name == 'forgot-password' || route.name == 'change-password' || route.name == 'reset-password',
        'standard-selection-page': route.name == 'index',
      }"
    >
      <div :class="isFullPage ? '' : 'container-fluid pt-3'">
        <router-view></router-view>
      </div>
    </div>

    <vue-easy-lightbox
      move-disabled
      :visible="imageVisible"
      :imgs="images"
      :index="imageIndex"
      @hide="setVisible(false)"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'

  import AppNavbar from './components/header/AppNavbar.vue'

  import useImageViewer from '@/modules/ImageViewer.js'

  export default {
    name: 'App',
    components: {
      AppNavbar,
    },
    setup() {
      const route = useRoute()
      const store = useStore()
      const {
        showImageIndex,
        showSingleImage,
        setVisible,
        setIndex,
        images,
        imageVisible,
        imageIndex,
      } = useImageViewer()

      const control_panel = computed(() => store.getters.selected_control_panel)

      const fullPages = ['login', 'forgot-password', 'reset-password', 'change-password', 'index']

      const isFullPage = computed(() => fullPages.includes(route.name))

      return {
        control_panel,
        route,
        isFullPage,

        showImageIndex,
        showSingleImage,
        setVisible,
        setIndex,
        images,
        imageVisible,
        imageIndex,
      }
    },
  }
</script>
